import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog,
} from "../types";

export const vendorSection = "/vendors/";

export const vendorListPath = vendorSection;

// NEW: Vendor My Orders paths
export const vendorMyOrdersPath = urlJoin(vendorSection, "my-orders");
export const vendorMyOrdersUrl = () => vendorMyOrdersPath;

export enum VendorListUrlFiltersEnum {
  joinedFrom = "joinedFrom",
  joinedTo = "joinedTo",
  numberOfOrdersFrom = "numberOfOrdersFrom",
  numberOfOrdersTo = "numberOfOrdersTo",
  query = "query",
}
export type VendorListUrlFilters = Filters<VendorListUrlFiltersEnum>;
export type VendorListUrlDialog = "remove" | TabActionDialog;
export enum VendorListUrlSortField {
  name = "name",
  email = "email",
  orders = "orders",
}
export type VendorListUrlSort = Sort<VendorListUrlSortField>;
export type VendorListUrlQueryParams = ActiveTab &
  BulkAction &
  VendorListUrlFilters &
  VendorListUrlSort &
  Dialog<VendorListUrlDialog> &
  Pagination;
export const vendorListUrl = (params?: VendorListUrlQueryParams) =>
  vendorListPath + "?" + stringifyQs(params);

export const vendorPath = (id: string) => urlJoin(vendorSection, id);
export type VendorUrlDialog = "remove";
export type VendorUrlQueryParams = Dialog<VendorUrlDialog>;
export const vendorUrl = (id: string, params?: VendorUrlQueryParams) =>
  vendorPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const vendorAddPath = urlJoin(vendorSection, "add");
export const vendorAddUrl = vendorAddPath;

export const vendorOfferingsPath = urlJoin(vendorSection, "management");
export const vendorOfferingsUrl = (params?: VendorListUrlQueryParams) =>
  vendorOfferingsPath + "?" + stringifyQs(params);

export const vendorAddressesPath = (id: string) => urlJoin(vendorPath(id), "addresses");
export type VendorAddressesUrlDialog = "add" | "edit" | "remove";
export type VendorAddressesUrlQueryParams = Dialog<VendorAddressesUrlDialog> & SingleAction;
export const vendorAddressesUrl = (id: string, params?: VendorAddressesUrlQueryParams) =>
  vendorAddressesPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

// PayPal Payment paths
export const vendorPayPalPaymentPath = urlJoin(vendorSection, "paypal/payment");
export const vendorPayPalPaymentUrl = () => vendorPayPalPaymentPath;